export default {
  get: {
    funKey: 'get',
    name: '基础功能',
    apis: [{
      path: '/basis/sys_config',
      method: 'GET'
    },
    {
      path: '/basis/sys_config',
      method: 'POST'
    }]
  }
}